import { ViewMode } from './Video.types';

export const tabs: { icon: string; view: ViewMode }[] = [
  { icon: 'table', view: ViewMode.grid },
  { icon: 'Checkbox', view: ViewMode.single },
];

export const vehicleKeys: {
  readonly route: 'Маршрут';
  readonly driver: 'Водитель';
  readonly ttype: 'Вид ТС';
  readonly gosNomer: 'ГРЗ';
  readonly model: 'Модель';
  readonly branch: 'Филиал';
  readonly depotNumber: 'Гаражный номер';
} = {
  ttype: 'Вид ТС',
  model: 'Модель',
  gosNomer: 'ГРЗ',
  depotNumber: 'Гаражный номер',
  route: 'Маршрут',
  driver: 'Водитель',
  branch: 'Филиал',
};
